import { useEffect, useState } from "react";
import { Plus, Trash2, FolderKanban } from "lucide-react";
import api from "../lib/api";
import { toast } from "sonner";

const COLORS = ["#FDE047", "#86EFAC", "#FDBA74", "#D8B4FE", "#7DD3FC", "#F9A8D4"];

export default function Categories() {
  const [cats, setCats] = useState([]);
  const [name, setName] = useState("");
  const [color, setColor] = useState(COLORS[0]);

  const load = async () => {
    const r = await api.get("/categories");
    setCats(r.data);
  };
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!name.trim()) return;
    await api.post("/categories", { name: name.trim(), color, icon: "BookOpen" });
    setName(""); setColor(COLORS[0]);
    toast.success("Category added");
    load();
  };

  const del = async (id) => {
    await api.delete(`/categories/${id}`);
    toast.success("Deleted");
    load();
  };

  return (
    <div className="p-6 sm:p-8 lg:p-12 max-w-4xl">
      <header className="mb-6">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Categories</p>
        <h1 className="font-display text-4xl font-black mt-1">Your subjects</h1>
        <p className="text-base font-medium text-slate-600 mt-2">Group words by subject — Biology, Maths, History, whatever you're studying.</p>
      </header>

      <div className="nb-card p-6 mb-8">
        <div className="grid sm:grid-cols-[1fr_auto_auto] gap-3 items-end">
          <div>
            <label className="text-xs uppercase font-bold tracking-widest">Name</label>
            <input data-testid="cat-name-input" value={name} onChange={(e)=>setName(e.target.value)} placeholder="e.g. Biology" className="nb-input mt-1"/>
          </div>
          <div>
            <label className="text-xs uppercase font-bold tracking-widest">Colour</label>
            <div className="flex gap-2 mt-1">
              {COLORS.map((c) => (
                <button key={c} type="button" data-testid={`cat-color-${c}`} onClick={() => setColor(c)} className={`w-9 h-9 rounded-md border-2 border-slate-900 ${color === c ? "ring-2 ring-slate-900 ring-offset-2" : ""}`} style={{ background: c }}/>
              ))}
            </div>
          </div>
          <button onClick={add} data-testid="cat-add-btn" className="nb-btn-primary inline-flex items-center gap-2 h-[46px]"><Plus className="w-4 h-4" strokeWidth={2.5}/> Add</button>
        </div>
      </div>

      {cats.length === 0 ? (
        <div className="nb-card p-12 text-center">
          <FolderKanban className="w-10 h-10 mx-auto" strokeWidth={2.5}/>
          <p className="font-display text-xl font-bold mt-3">No categories yet</p>
          <p className="text-sm text-slate-600">Create one above to start organising your glossary.</p>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cats.map((c) => (
            <div key={c.id} data-testid={`cat-card-${c.name}`} className="nb-card p-5" style={{ background: c.color }}>
              <FolderKanban className="w-7 h-7" strokeWidth={2.5}/>
              <h3 className="font-display text-xl font-bold mt-3">{c.name}</h3>
              <button onClick={() => del(c.id)} data-testid={`cat-delete-${c.name}`} className="mt-4 nb-btn-secondary text-xs inline-flex items-center gap-1 py-2 px-3">
                <Trash2 className="w-3 h-3" strokeWidth={2.5}/> Delete
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
